<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="85"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item
        v-if="mold !== 'rk'"
        label-width="90px"
        label="查询服务商"
        slot="contractType"
        style="margin: 0"
      >
        <el-select
          :popper-append-to-body="false"
          v-model="channel"
          placeholder="请选择服务商查询"
          clearable
          filterable
        >
          <el-option
            v-for="item in goodsStateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label-width="70px"
        :label="mold === 'rk' ? '品牌' : '旧机品牌'"
        slot="Oldmachinebrand"
        style="margin: 0"
      >
        <el-select
          :popper-append-to-body="false"
          v-model="brand"
          placeholder="请选择或输入品牌查询"
          clearable
          filterable
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import moment from "moment";
import {
  brandPull,
  channePull,
} from "../../../utils/request/changePhone";
export default {
  name: "Form",
  props: {
    mold: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      brand: "",
      channel: "",
      productList: [],
      initData: null,
      goodsStateList: [],
      formRules: {},
      SeachParams: {},
    };
  },
  computed: {
    // 入库记录仅展示串号和品牌，其他页签保留完整筛选条件
    formItemList() {
      const items = [
        { slotName: "contractType" },
        {
          key: "imei",
          type: "input",
          labelName: "串号",
          placeholder: "请输入串号查询",
          labelWidth: "50px",
        },
        { slotName: "Oldmachinebrand" },
        {
          labelWidth: "80px",
          key: "entryTime",
          type: "daterange",
          labelName: "查询时间",
          placeholder: "请选择查询时间",
          valueFormat: "timestamp",
        },
      ];
      return this.mold === "rk"
        ? items.filter(
            (item) => !["contractType", "entryTime"].includes(item.slotName || item.key)
          )
        : items;
    },
  },
  created() {
    this.getChannePull();
    this.getBrandPull();
    this.handleConfirm();
  },
  methods: {
    // 获取服务商筛选项
    getChannePull() {
      channePull().then((res) => {
        this.goodsStateList = res.data;
      });
    },
    // 获取品牌筛选项
    getBrandPull() {
      brandPull().then((res) => {
        this.productList = res.data;
      });
    },
    // 提交筛选条件，由列表组件监听并重新请求第一页数据
    handleConfirm(data, cd) {
      const entryTime = data && data.entryTime;
      const baseRequest = {
        imei: data && data.imei ? data.imei : "",
        brand: this.brand,
        channel: this.channel,
        beg_time: entryTime ? Number(moment(entryTime[0]).format("x")) : "",
        end_time: entryTime ? Number(moment(entryTime[1]).format("x")) : "",
        disuseLoding: () => {
          if (typeof cd === "function") {
            cd();
          }
        },
      };
      this.SeachParams = baseRequest;
      this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  /deep/.el-select-dropdown {
    border-radius: 20px;
  }

  .select_down {
    /deep/.el-popper {
      border-radius: 20px;
    }

    /deep/.el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #e4ecfd;
      color: rgba(9, 129, 255, 1);
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .time-type {
    /deep/.el-input__inner {
      border: none;
    }
  }
}
</style>
